"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styles = require("../styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var LocalAdmin = function LocalAdmin(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/React.createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M11.45 14.454c.006.017.011.035.018.052a.63.63 0 0 0 .108.192l1.235 1.494-1.362 5.734a.63.63 0 0 0 .164.588l1.891 1.919a.63.63 0 0 0 .89.008l1.957-1.92a.63.63 0 0 0 .172-.595l-1.363-5.734 1.235-1.494.002-.002a1.24 1.24 0 0 0 .156-.241 8.614 8.614 0 0 1 6.057 8.225.63.63 0 1 0 1.26 0c0-4.75-3.354-8.715-7.823-9.657a4.83 4.83 0 1 0-4.19.02c-4.421.98-7.727 4.922-7.727 9.637a.63.63 0 0 0 1.26 0c0-3.868 2.55-7.14 6.06-8.226Zm1.314-.296a8.679 8.679 0 0 1 2.446-.004l-1.032 1.249h-.385l-1.029-1.245Zm1.166-1.908a3.57 3.57 0 1 0 0-7.14 3.57 3.57 0 0 0 0 7.14Zm.056 4.45-1.23 5.178 1.205 1.223 1.253-1.23-1.228-5.172Z",
    clipRule: "evenodd"
  }));
};
var _default = exports["default"] = LocalAdmin;